if (!customElements.get('ap-freeshippingbar')) {
    class FreeShippingBar extends HTMLElement {
        static currentFillProgress = [];
        static wasFreePreviously = false;
        static previousActiveStates = [];

        constructor() {
            super();
        }

        connectedCallback() {
            this.initializeBar();
        }

        async initializeBar() {
            await this.waitForGSAP();

            this.fills = this.querySelectorAll('.shipping-bar__fill');
            this.textWrapper = this.querySelector('.shipping-bar__text-wrapper');
            this.progressBar = this.querySelector('.shipping-bar__progress');
            this.checkpoints = this.querySelectorAll('.shipping-bar__checkpoint');

            if (!this.fills.length || !this.textWrapper || !this.progressBar) {
                return;
            }

            const segmentCount = this.fills.length;

            // Read checkpoints from data attribute
            const checkpointsData = JSON.parse(this.getAttribute('data-checkpoints') || '[]');
            const currentQuantity = parseFloat(this.getAttribute('data-current-quantity') || '0');
            const hasFreeShippingProduct = this.getAttribute('data-has-free-shipping-product') === 'true';
            const freeShippingThreshold = checkpointsData.length > 0
                ? checkpointsData[checkpointsData.length - 1].threshold
                : 0;

            // Initialize previousActiveStates from DOM on first load
            if (!FreeShippingBar.previousActiveStates.length) {
                FreeShippingBar.previousActiveStates = Array.from(this.checkpoints).map(
                    cp => cp.classList.contains('active')
                );
            }

            // Initialize currentFillProgress array if empty
            if (!FreeShippingBar.currentFillProgress.length) {
                FreeShippingBar.currentFillProgress = new Array(segmentCount).fill(0);
            }

            // Calculate overall progress (mirrors Liquid logic)
            let overallProgress = 0;
            const segmentWidth = 1.0 / segmentCount;

            if (hasFreeShippingProduct || currentQuantity >= freeShippingThreshold) {
                overallProgress = 1.0;
            } else {
                let foundSegment = false;
                // Walk segments from last to first
                for (let i = segmentCount; i >= 1; i--) {
                    const segStart = checkpointsData[i - 1].threshold;
                    const segEnd = checkpointsData[i].threshold;

                    if (!foundSegment && currentQuantity >= segStart) {
                        const range = segEnd - segStart;
                        let segProgress = range > 0
                            ? Math.min((currentQuantity - segStart) / range, 1.0)
                            : 1.0;
                        overallProgress = ((i - 1) * segmentWidth) + (segProgress * segmentWidth);
                        foundSegment = true;
                        break;
                    }
                }

                if (!foundSegment && currentQuantity > 0 && checkpointsData.length > 0) {
                    // Below first checkpoint — partial progress in first segment
                    const firstThreshold = checkpointsData[0].threshold;
                    if (firstThreshold > 0) {
                        const segProgress = Math.min(currentQuantity / firstThreshold, 1.0);
                        overallProgress = segProgress * segmentWidth;
                    }
                }

                overallProgress = Math.min(overallProgress, 1.0);
            }

            // Calculate per-segment fill percentages
            const fillProgress = [];
            for (let i = 0; i < segmentCount; i++) {
                const segStart = i * segmentWidth;
                const segEnd = (i + 1) * segmentWidth;

                if (overallProgress >= segEnd) {
                    fillProgress.push(100);
                } else if (overallProgress > segStart) {
                    fillProgress.push(((overallProgress - segStart) / segmentWidth) * 100);
                } else {
                    fillProgress.push(0);
                }
            }

            // Determine which checkpoints should be active
            const shouldBeActive = checkpointsData.map(cp => {
                if (hasFreeShippingProduct) return true;
                return currentQuantity >= cp.threshold;
            });

            // Animate fills with GSAP
            const timeline = gsap.timeline();
            const fillElements = Array.from(this.fills);

            timeline.fromTo(fillElements,
                {
                    width: (i) => `${(FreeShippingBar.currentFillProgress[i] || 0)}%`
                },
                {
                    width: (i) => `${fillProgress[i]}%`,
                    duration: 0.3,
                    ease: "power2.out"
                }
            );

            // After fills animate, update checkpoints
            timeline.call(() => {
                this.checkpoints.forEach((checkpoint, index) => {
                    const shouldBe = shouldBeActive[index];
                    if (shouldBe) {
                        if (!checkpoint.classList.contains('active')) {
                            checkpoint.classList.add('active', 'animating');
                            setTimeout(() => {
                                checkpoint.classList.remove('animating');
                            }, 300);
                        }
                    } else if (checkpoint.classList.contains('active')) {
                        checkpoint.classList.remove('active');
                    }
                });

                // Store state for next run
                FreeShippingBar.previousActiveStates = shouldBeActive.slice();
                FreeShippingBar.currentFillProgress = fillProgress.slice();
                FreeShippingBar.wasFreePreviously = currentQuantity >= freeShippingThreshold;
            });

            // Handle text fade if free shipping state changed
            if ((currentQuantity >= freeShippingThreshold) !== FreeShippingBar.wasFreePreviously) {
                timeline.fromTo(this.textWrapper,
                    { opacity: 0 },
                    {
                        opacity: 1,
                        duration: 0.5
                    }
                );
            }
        }

        waitForGSAP() {
            return new Promise(resolve => {
                if (window.gsap) {
                    resolve();
                } else {
                    const checkGSAP = setInterval(() => {
                        if (window.gsap) {
                            clearInterval(checkGSAP);
                            resolve();
                        }
                    }, 50);
                }
            });
        }
    }
    customElements.define('ap-freeshippingbar', FreeShippingBar);
}